import { newsletterService } from "./newsletter.service"
import { feedbackService } from "./userMessage.service";
import "./tbw-newsletter-form.component.scss";

export const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

const NEWSLETTER_REDIRECT_URL = import.meta.env.VITE_NEWSLETTER_REDIRECT_URL;
const FRENCH_NEWSLETTER_ID = import.meta.env.VITE_NEWSLETTER_FRENCH_ID;
const ENGLISH_NEWSLETTER_ID = import.meta.env.VITE_NEWSLETTER_ENGLISH_ID;

export class TbwNewsletterFormComponent extends HTMLElement {
  private currentLanguage = "english";

  private options = {
    french: {
      value: "french",
      short: "FR",
      flag: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512"><clipPath id="fr-round-mask"><circle cx="50%" cy="50%" r="50%" fill="white" /></clipPath><g clip-path="url(#fr-round-mask)"><g fill-rule="evenodd" stroke-width="1pt"><path fill="#fff" d="M0 0h512v512H0z"/><path fill="#00267f" d="M0 0h170.7v512H0z"/><path fill="#f31830" d="M341.3 0H512v512H341.3z"/></g></g></svg>`,
      alt: "Français"
    },
    english: {
      value: "english",
      short: "EN",
      flag: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512"><clipPath id="gb-round-mask"><circle cx="50%" cy="50%" r="50%" fill="white" /></clipPath><g clip-path="url(#gb-round-mask)"><path fill="#012169" d="M0 0h512v512H0z"/><path fill="#FFF" d="M512 0v64L322 256l190 187v69h-67L254 324 68 512H0v-68l186-187L0 74V0h62l192 188L440 0z"/><path fill="#C8102E" d="M184 324l11 34L42 512H0v-3l184-185zm124-12l54 8 150 147v45L308 312zM512 0L320 196l-4-44L466 0h46zM0 1l193 189-59-8L0 49V1z"/><path fill="#FFF" d="M176 0v512h160V0H176zM0 176v160h512V176H0z"/><path fill="#C8102E" d="M0 208v96h512v-96H0zM208 0v512h96V0h-96z"/></g></svg>`,
      alt: "English"
    },
  };

  constructor() {
    super()
  }

  connectedCallback() {
    this.render();
    this.initializeEventListeners();
  }

  private getPageLanguage(): 'french' | 'english' {
    try {
      const isFrench = window.location.pathname.includes('/fr')
      return isFrench ? 'french' : 'english'
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
      return 'french'; // Default to French if localStorage is not accessible
    }
  }

  render(): void {
    const pageLanguage = this.getPageLanguage();
    const defaultLanguageOption = this.options[pageLanguage];

    this.innerHTML = `
      <div class="newsletter-management-container">
        <form class="newsletter-form_div newsletter-form">
          <input
            type="email"
            class="text-input is-full-width newsletter-email"
            name="email"
            placeholder="Enter your email"
          />

          <div class="select-dropdown-container">
            <div class="custom-select">
              <button type="button" class="select-button" id="language-selector">
                <span class="language-short">${defaultLanguageOption.short}</span>
                <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.925 -1.24191e-05L10.8083 0.884154L5.99417 5.69999C5.91703 5.77762 5.8253 5.83922 5.72426 5.88126C5.62321 5.9233 5.51486 5.94495 5.40542 5.94495C5.29598 5.94495 5.18762 5.9233 5.08658 5.88126C4.98554 5.83922 4.89381 5.77762 4.81667 5.69999L0 0.884154L0.883333 0.0008202L5.40417 4.52082L9.925 -1.24191e-05Z" fill="#161032"/>
                </svg>
              </button>

              <div class="select-dropdown" id="language-dropdown">
                <div class="select-option" id="dropdown-option"></div>
              </div>
              <input type="hidden" name="language" value="${pageLanguage}" />
            </div>
          </div>

          <button
            class="newsletter-submit-button"
            type="button"
          ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.172 8.778L-3.83699e-07 8.778L-2.96276e-07 6.778L12.172 6.778L6.808 1.414L8.222 -3.39987e-07L16 7.778L8.222 15.556L6.808 14.142L12.172 8.778Z" fill="white"/>
          </svg>
          </button>
        </form>

        <div class="newsletter-message-container">
          <div class="newsletter_signup-success_message is-text"></div>
          <div class="nl-subscription_error-message is-text"></div>
        </div>
      </div>
    `;
  }

  private initializeEventListeners(): void {
    this.initializeDropdown();
    this.initializeSubmitButton();
    this.initializeDropdownState();
  }

  private initializeDropdown(): void {
    const languageSelector = this.querySelector(".select-button");
    const languageDropdown = this.querySelector(".select-dropdown");
    const languageInput = this.querySelector("input[name='language']") as HTMLInputElement;

    if (!languageSelector || !languageDropdown || !languageInput) {
      console.error("Language dropdown elements not found");
      return;
    }

    // Toggle dropdown on button click
    languageSelector.addEventListener("click", (e) => {
      e.preventDefault();
      languageDropdown.classList.toggle("show");
    });

    // Handle option selection
    const optionElements = languageDropdown.querySelectorAll(".select-option");
    optionElements.forEach((optionElement) => {
      optionElement.addEventListener("click", () => {
        const value = optionElement.getAttribute("data-value");
        const flagSrc = optionElement.getAttribute("data-short");
        const flagAlt = optionElement.getAttribute("data-alt");

        if (value && flagSrc && flagAlt) {
          languageInput.value = value;
          this.currentLanguage = value;

          // Update button flag based on selected language
          const flagIcon = languageSelector.querySelector(".language-short") as HTMLElement;
          if (flagIcon && flagSrc) {
            flagIcon.innerHTML = flagSrc;
          }

          // Update dropdown to show the inactive option
          this.updateDropdownForSelection(value);
          languageDropdown.classList.remove("show");
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (
        !languageSelector.contains(e.target as Node) &&
        !languageDropdown.contains(e.target as Node)
      ) {
        languageDropdown.classList.remove("show");
      }
    });
  }

  private initializeDropdownState(): void {
    const pageLanguage = this.getPageLanguage();
    // Set the initial inactive option (the opposite of the page language) in the dropdown
    const inactiveLanguage = pageLanguage === "french" ? "english" : "french";
    this.updateDropdownOption(inactiveLanguage);
  }

  private updateDropdownOption(language: string): void {
    const dropdownOption = this.querySelector("#dropdown-option");
    if (!dropdownOption) return;

    const option = this.options[language as keyof typeof this.options];
    if (!option) return;

    dropdownOption.setAttribute("data-value", option.value);
    dropdownOption.setAttribute("data-flag", option.flag);
    dropdownOption.setAttribute("data-alt", option.alt);
    dropdownOption.setAttribute("data-short", option.short)
    dropdownOption.innerHTML = `
      <span class="language-short">${option.short}</span>
    `;
  }

  private updateDropdownForSelection(selectedLanguage: string): void {
    // Find the inactive language (the one not currently selected)
    const inactiveLanguage = selectedLanguage === "french" ? "english" : "french";
    this.updateDropdownOption(inactiveLanguage);
  }

  private initializeSubmitButton(): void {
    const submitButton = this.querySelector(".newsletter-submit-button");
    if (!submitButton) {
      console.error("Submit button not found");
      return;
    }

    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  }

  public setEmailInputValue(email: string): void {
    const emailSelector = this.querySelector(".newsletter-email") as HTMLInputElement;
    if (emailSelector) {
      emailSelector.value = email;
      emailSelector.disabled = true;
      emailSelector.style.cursor = "not-allowed";
    }
  }

  private async handleSubmit(): Promise<void> {
    feedbackService.hideMessages(this);
    feedbackService.setSubmitButtonLoading(true, this);

    try {
      const form: HTMLFormElement | null = this.querySelector(".newsletter-form");
      if (!form) {
        throw new Error("Form not found");
      }

      const emailSelector = form.querySelector(".newsletter-email") as HTMLInputElement;
      const languageSelector = form.querySelector("input[name='language']") as HTMLInputElement;

      if (validateEmail(emailSelector.value) === false) {
        const errorMessage = "Please enter a valid email address";
        throw new Error(errorMessage);
      }

      const email = emailSelector.value;
      const language = languageSelector.value;

      const id = language === "french" ? FRENCH_NEWSLETTER_ID : ENGLISH_NEWSLETTER_ID;
      if (!id) {
        const errorMessage = "Newsletter IDs not configured. Set VITE_NEWSLETTER_FRENCH_ID and VITE_NEWSLETTER_ENGLISH_ID.";
        throw new Error(errorMessage);
      }

      const response = await newsletterService.subscribe(email, id);

      const successMessage = "Success ! You are subscribed to the newsletter";
      feedbackService.showSuccessMessage(successMessage, this);

      window.tbwServices.analyticsService.track("newsletter_signup", { newsletter_id: id });

      setTimeout(() => {
        window.location.replace(NEWSLETTER_REDIRECT_URL);
      }, 1000);

      return response;
    } catch (error: any) {
      let errorMessage = error.message;
      feedbackService.showErrorMessage(errorMessage, this);
    } finally {
      feedbackService.setSubmitButtonLoading(false, this);
    }
  }
}
